import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useParams } from "react-router-dom";
import * as Styles from "./styles";

interface Props {
  handleOpenProposta: () => void;
  selectedItem: any;
  idLead: string | undefined;
  onClose: () => void;
  leadProducts: { label: string; value: string; idLeadCorretor: string };
  dataResumo: any;
  dataVincularCodigo: any;
}

const Footer: React.FC<Props> = (props) => {
  const params: any = useParams();
  const handleRepasseAssociativoClick = () => {
    if (props.idLead !== undefined) {
      window.location.pathname = `lead-detail/${
        params.idLeadCorretor || props.dataVincularCodigo?.idLeadCorretor
      }/repasse-associativo/${props.selectedItem?.idUnidade}`;
    } else {
      window.location.pathname = `lead-detail/${
        props.leadProducts.idLeadCorretor ||
        props.dataVincularCodigo?.idLeadCorretor
      }/repasse-associativo/${props.selectedItem?.idUnidade}`;
    }
  };

  const handleRepasseChavesClick = () => {
    if (props.idLead !== undefined) {
      window.location.pathname = `lead-detail/${
        params.idLeadCorretor || props.dataVincularCodigo?.idLeadCorretor
      }/${props.idLead || props.dataVincularCodigo?.idLead}/repasse-chaves/${
        props.selectedItem?.idUnidade
      }`;
    } else {
      window.location.pathname = `lead-detail/${
        props.leadProducts.idLeadCorretor ||
        props.dataVincularCodigo?.idLeadCorretor
      }/${
        props.leadProducts.value || props.dataVincularCodigo?.idLead
      }/repasse-chaves/${props.selectedItem?.idUnidade}`;
    }
  };

  return (
    <Styles.Container>
      {props.dataResumo?.simuladorAssociativo === true && (
        <Styles.Button
          onClick={() => {
            handleRepasseAssociativoClick();
          }}
        >
          <Styles.LightText>PV Repasse Associativo</Styles.LightText>
          <MdKeyboardArrowRight size={20} />
        </Styles.Button>
      )}

      <Styles.Button
        onClick={() => {
          handleRepasseChavesClick();
          props.onClose();
        }}
      >
        <Styles.LightText>PV Repasse Chaves | Fluxo Direto</Styles.LightText>
        <MdKeyboardArrowRight size={20} />
      </Styles.Button>
    </Styles.Container>
  );
};

export default Footer;
